const EventUpcoming = () => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon">
      <mask
        id="mask0_819_19373"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
      >
        <rect id="Bounding box" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_819_19373)">
        <path
          id="event_upcoming"
          d="M11.25 16.5V15H14.25V7.5H3.75V10.5H2.25V4.5C2.25 4.0875 2.39688 3.73438 2.69063 3.44063C2.98438 3.14688 3.3375 3 3.75 3H4.5V1.5H6V3H12V1.5H13.5V3H14.25C14.6625 3 15.0156 3.14688 15.3094 3.44063C15.6031 3.73438 15.75 4.0875 15.75 4.5V15C15.75 15.4125 15.6031 15.7656 15.3094 16.0594C15.0156 16.3531 14.6625 16.5 14.25 16.5H11.25ZM6 18L4.95 16.95L6.88125 15H0.75V13.5H6.88125L4.95 11.55L6 10.5L9.75 14.25L6 18ZM3.75 6H14.25V4.5H3.75V6Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default EventUpcoming;
